module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/getincar/getincar.component.css
// module id = ./src/app/getincar/getincar.component.css
// module chunks = main